export default "__VITE_ASSET__6dac6035__"